const siteTopbar = document.querySelector('.site-topbar');
const container = document.querySelector('.container');

// Add an event listener to the window scroll event
window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const topbarY = siteTopbar.offsetTop + siteTopbar.offsetHeight;
    const minimalHeaderY = topbarY + 100;

    // Check if the scroll position is greater than the topbar height
    if (scrollY > topbarY) {
        container.classList.add('has-fixed-header');
    } else {
        container.classList.remove('has-fixed-header');
    }

    // Check if the scroll position is greater than the topbar height
    if (scrollY > minimalHeaderY) {
        container.classList.add('has-minimal-header');
    } else {
        container.classList.remove('has-minimal-header');
    }
});